import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import { getIcons } from "../../Constant/Constant";
import CallLog from "../../AnalyticsComponent/CallLog";
import { Chart } from "primereact/chart";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, set } from "date-fns";
import CallLogService from "../../Services/CallLogService";
import { showErrorToast } from "../../Constant/Notification";
import CheckInAndCheckOutService from "../../Services/CheckInAndCheckOutService";
import TodayTeamActivityService from "../../Services/TodayTeamActivityService";
import teamService from "../../Services/TeamService";
import { baseUrl } from "../../../config/clientsConfig";
import { useNavigate, useNavigation } from "react-router-dom";
import { getBasePathByUserRole } from "../../../utils/roleRoutes";
import ActivityTabelFilter from "./ActivityTabelFilter";
import { MdFilterListAlt } from "react-icons/md";
import { features } from "../../../config/featureConfig";
import { IoLogoDropbox } from "react-icons/io";

const TodayteamActivity = ({ teamId, mdTeamId, teamName }) => {
  const [team, setTeam] = useState({});
  const [selectedMemberList, setSelectedMemberList] = useState([]);
  const [headerName, setHeaderName] = useState("");
  const [analytics, setAnalytics] = useState({});
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState(null);
  const initialDate = format(new Date(), "yyyy-MM-dd");

  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [callLogHistory, setCallLogHistory] = useState([]);
  const [checkInAndCheckOut, setCheckInAndCheckOut] = useState([]);
  const [totalCallTime, setTotalCallTime] = useState(0);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const bodTeamId = userData?.teamId?.[0]?.id;
  const bodUserId = userData?.user?.uid;
  console.log(bodUserId);

  const bookingStage = "Q9JZE1p3V8dahjH8eMwl";
  const registrationStage = "OeC8MZqNykSosVgiPIGx";

  const chartRef = useRef(null);
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [selectedTime, setSelectedTime] = useState(null);
  const [callCount, setCallCount] = useState(0);

  const navigate = useNavigate();

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [startType, setStartType] = useState("");

  useEffect(() => {
    if (!selectedUserId || !selectedDate) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/analytics/callLog-graph?docId=${selectedUserId}&startDate=${selectedDate}`
        );

        const callLogs = response.data.data; // API returns { data: [{ timeRange: "0:00 - 2:00", count: X }, ...] }

        // Extract labels and data
        const labels = callLogs.map((log) => log.timeRange);
        const dataPoints = callLogs.map((log) => log.count);

        setChartData({
          labels: labels,
          datasets: [
            {
              data: dataPoints,
              fill: true,
              borderColor: "rgb(57, 158, 121)",
              tension: 0.4,
              backgroundColor: "rgba(57, 158, 121, 0.3)",
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching call log data:", error);
      }
    };

    fetchData();
  }, [selectedUserId, selectedDate]); // Re-run effect when docId or startDate changes

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

    setChartOptions({
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      responsive: true,
      plugins: {
        legend: {
          display: false,
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            display: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            display: false,
          },
        },
      },
      onClick: (e) => {
        const chartInstance = chartRef.current.chart;
        const points = chartInstance.getElementsAtEventForMode(
          e.native,
          "nearest",
          { intersect: true },
          true
        );
        if (points.length) {
          const { index } = points[0];
          setSelectedTime(chartData.labels[index]);
          setCallCount(chartData.datasets[0].data[index]);
        }
      },
    });
  }, [chartData]);

  const fetchActivityCount = async (teamId) => {
    try {
      const response = await TodayTeamActivityService.getTodayActivityCount(
        teamId
      );
      console.log("Activity Count Response:", selectedMemberList);
      setAnalytics(response.data.userActivity || {});
      setSelectedMemberList(
        response.data?.userActivity.map((user) => ({
          label: user.name,
          value: user.userId,
        }))
      );
    } catch (error) {
      console.error("Error fetching activity count:", error);
    }
  };
  useEffect(() => {
    if (teamId) {
      fetchActivityCount(teamId);
    }
    if (mdTeamId) {
      fetchActivityCount(mdTeamId);
    }
  }, [teamId, mdTeamId]);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "80%",
      padding: "20px",
      position: "relative",
      transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
    },
    overlay: {
      zIndex: 1000,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      transition: "opacity 0.3s ease-out",
    },
  };

  // Bind modal to your appElement
  Modal.setAppElement("#root");

  const handleModalOpen = (userId, userName) => {
    setSelectedUserId(userId);

    setSelectedUserName(userName);
    setIsModalOpen(true);
  };

  const handleNavigateToAnalytics = (user, userName) => {
    console.log("Selected Member List:", user);
    const path = getBasePathByUserRole();
    navigate(`${path}/user-analytics`, {
      state: {
        userName,
        teamName: teamName?.name,
        user,
        teamId,
        mdTeamId,
        memberList: selectedMemberList,
      },
    });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCallLogHistory([]);
    setCheckInAndCheckOut([]);
    setSelectedDate(initialDate);
  };
  const icon = getIcons();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await CallLogService.getCallLogHistory(
          selectedUserId,
          selectedDate
        );
        console.log("Response:", response.data);
        setCallLogHistory(response.data);
        const totalDuration = response.data.reduce(
          (acc, call) => acc + call.callDurationInSeconds,
          0
        );
        console.log("Total Duration:", totalDuration);
        setTotalCallTime(totalDuration);
      } catch (error) {
        setTotalCallTime(0);
        console.log(error);
      }
    };

    fetchData();
  }, [selectedUserId, selectedDate]);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await CheckInAndCheckOutService.getData(
          selectedUserId,
          selectedDate
        );
        console.log("Response:", response.data);
        setCheckInAndCheckOut(response.data);
      } catch (error) {
        console.log(error);
        if (error.response?.status === 404) {
          setCheckInAndCheckOut([]);
        }
      }
    };
    fetchdata();
  }, [selectedDate, selectedUserId]);

  const breakTimes =
    Array.isArray(checkInAndCheckOut) &&
    checkInAndCheckOut
      .filter((item) => item.type === 2)
      .sort((a, b) => a.timestamp.localeCompare(b.timestamp));

  const checkInTime =
    (Array.isArray(checkInAndCheckOut) &&
      checkInAndCheckOut.find((item) => item.type === 1)?.timestamp) ||
    "No Data";
  const checkOutTime =
    (Array.isArray(checkInAndCheckOut) &&
      checkInAndCheckOut.find((item) => item.type === 3)?.timestamp) ||
    "No Data";

  const formatCallTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours} H : ${minutes} Min`;
  };

  const convertToMinutes = (time) => {
    const [timePart, modifier] = time.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);
    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    }
    if (modifier === "AM" && hours === 12) {
      hours = 0;
    }
    return hours * 60 + minutes;
  };

  const calculateWorkingHours = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) return null;

    const checkInMinutes = convertToMinutes(checkIn);
    const checkOutMinutes = convertToMinutes(checkOut);
    const diffMinutes = checkOutMinutes - checkInMinutes;

    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    return `${hours}H : ${minutes}M`;
  };

  const calculateTotalBreakTime = (breakTimes) => {
    let totalBreakMinutes = 0;

    Array.isArray(breakTimes) &&
      breakTimes.forEach((breakTime) => {
        const breakStartMinutes = convertToMinutes(breakTime.timestamp);
        const breakEndMinutes = convertToMinutes(breakTime.breakTimestamp);
        totalBreakMinutes += breakEndMinutes - breakStartMinutes;
      });

    const hours = Math.floor(totalBreakMinutes / 60);
    const minutes = totalBreakMinutes % 60;
    return `${hours}H : ${minutes}M`;
  };
  const workingHours = calculateWorkingHours(checkInTime, checkOutTime);
  const totalBreakTime = calculateTotalBreakTime(breakTimes);
  const handleApplyFilter = (filter) => {};
  const clearFilters = () => {};

  return (
    <div className="">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-semibold text-gray-800 mb-4 border-b-4 border-customGreen inline-block">
          Today Team Activity
        </h3>
        {/* <button
                        onClick={() => {
                          setIsFilterOpen(!isFilterOpen);
                        }}
                        className="bg-white  justify-between text-base font-medium w-[131px] h-[50px] rounded-[10px]   flex items-center gap-3 text-customGreen py-2 px-4  hover:bg-appGreenHover transition duration-300"
                      >
                        Filters
                        <MdFilterListAlt />
                      </button> */}
      </div>

      <div className="border bg-white p-4 rounded-lg overflow-hidden shadow-lg w-full">
        <table className="w-full bg-white border-collapse">
          <thead>
            <tr className="border-b border-gray-300 text-center">
              <th className="p-4 text-gray-600 border-r border-gray-300">
                {headerName || "Name"}
              </th>
              <th className="p-4 text-gray-600 border-r border-gray-300">
                SIM Calls
              </th>
              {features.ivrCalls && (
                <th className="p-4 text-gray-600 border-r border-gray-300">
                  IVR Calls
                </th>
              )}
              <th className="p-4 text-gray-600 border-r border-gray-300">
                Messages
              </th>
              <th className="p-4 text-gray-600 border-r border-gray-300">
                WhatsApp
              </th>
              {features?.ivrCalls && (
                <th className="p-4 text-gray-600 border-r border-gray-300">
                  Template WhatsApp count
                </th>
              )}
              <th className="p-4 text-gray-600 border-r border-gray-300">
                Created Deals
              </th>
              <th className="p-4 text-gray-600 border-r border-gray-300">
                Site Visits
              </th>
              <th className="p-4 text-gray-600 border-r border-gray-300">
                Bookings
              </th>
              <th className="p-4 text-gray-600">Registrations</th>
            </tr>
          </thead>
          <tbody>
            {analytics.length > 0 ? (
              analytics.map((member) => (
                <tr
                  key={member.id}
                  className="border-b border-gray-300 text-center"
                >
                  <td
                    onClick={() =>
                      handleNavigateToAnalytics(member, member.name)
                    }
                    className="p-4 text-[#2280FF] hover:text-[#223fff] hover:underline border-r cursor-pointer border-gray-300"
                  >
                    {member.name}
                  </td>
                  <td className="p-4 text-gray-700 border-r border-gray-300">
                    <div className="flex flex-col items-center gap-1">
                      <span className="font-semibold text-gray-800">
                        {member.simCalls?.total || 0}
                      </span>
                      <div className="flex gap-2">
                        <span className="px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-600">
                          ✓ {member.simCalls?.attended || 0}
                        </span>
                        <span className="px-2 py-0.5 text-xs rounded-full bg-red-100 text-red-600">
                          ✗ {member.simCalls?.notAttended || 0}
                        </span>
                      </div>
                    </div>
                  </td>

                  {features.ivrCalls && (
                    <td className="p-4 text-gray-700 border-r border-gray-300">
                      <div className="flex flex-col items-center gap-1">
                        <span className="font-semibold text-gray-800">
                          {member.ivrCalls?.total || 0}
                        </span>
                        <div className="flex gap-2">
                          <span className="px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-600">
                            ✓ {member.ivrCalls?.attended || 0}
                          </span>
                          <span className="px-2 py-0.5 text-xs rounded-full bg-red-100 text-red-600">
                            ✗ {member.ivrCalls?.notAttended || 0}
                          </span>
                        </div>
                      </div>
                    </td>
                  )}

                  <td className="p-4 text-gray-700 border-r border-gray-300">
                    {member.messagesCount || 0}
                  </td>
                  <td className="p-4 text-gray-700 border-r border-gray-300">
                    {member.whatsappCount || 0}
                  </td>
                  {features.ivrCalls && (
                    <td className="p-4 text-gray-700 border-r border-gray-300">
                      {member.templateWhatsappMessageCount || 0}
                    </td>
                  )}
                  <td className="p-4 text-gray-700 border-r border-gray-300">
                    {member.createdDealsCount || 0}
                  </td>
                  <td className="p-4 text-gray-700 border-r border-gray-300">
                    {member.siteVisitCount || 0}
                  </td>
                  <td className="p-4 text-gray-700 border-r border-gray-300">
                    {member.bookingCount || 0}
                  </td>
                  <td className="p-4 text-gray-700">
                    {member.registrationCount || 0}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={features.ivrCalls ? 9 : 8}
                  className="p-6 h-[400px] text-center text-gray-500"
                >
                  <div>
                    <IoLogoDropbox className="text-[100px] text-gray-300 mx-auto mb-4" />
                  </div>
                  No activity data available for the selected team.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Create Team"
        style={customStyles}
        closeTimeoutMS={300}
        className={""}
      >
        <div className="flex justify-between">
          <div className="w-auto ">
            <div className="flex gap-2">
              User Name:{" "}
              <h6 className="font-semibold w-48 whitespace-nowrap truncate">
                {" "}
                {selectedUserName}
              </h6>
            </div>
            <div className="flex gap-2">
              Team:{" "}
              <h6 className="font-semibold w-48 whitespace-nowrap truncate">
                {headerName}
              </h6>
            </div>
          </div>
          <div className="flex gap-2">
            <div className="flex gap-2 border border-gray-400 rounded-lg p-2 w-auto">
              <h1>Date:</h1>
              <DatePicker
                selected={selectedDate}
                className="focus:outline-none "
                onChange={(date) => {
                  const formattedDate = format(date, "yyyy-MM-dd");
                  setSelectedDate(formattedDate);
                }}
                maxDate={new Date(new Date().setDate(new Date().getDate()))}
                dateFormat="dd/MM/yyyy"
              />
            </div>
            <button
              onClick={handleCloseModal}
              className=" text-2xl  text-gray-700"
            >
              &times;
            </button>
          </div>
        </div>

        <div className="flex  border border-gray-400 rounded-lg p-2 shadow-sm m-3">
          <div className="flex  ">
            <div className="border-r w-64 border-gray-400 ">
              <div className="flex gap-2">
                <img src={icon.checkIn} alt="" />
                <div>
                  <h4 className="text-base">Day check In</h4>
                  <h6 className="text-sm ">{checkInTime || "No Data"}</h6>
                </div>
              </div>

              <div className="flex gap-2">
                <img src={icon.checkOut} alt="" />
                <div>
                  <h4 className="text-base">Day check Out</h4>
                  <h6 className="text-sm ">{checkOutTime || "No Data"}</h6>
                </div>
              </div>
            </div>

            <div className="border-r w-64 border-gray-400 ">
              <div className="flex gap-2 px-2">
                <img src={icon.breakTime} alt="" />
                <div>
                  <h4 className="text-base">Break</h4>
                  {Array.isArray(breakTimes) && (
                    <div className="h-14 overflow-y-auto scrollbar-hidden">
                      {breakTimes.map((breakTime, index) => (
                        <div key={index} className="">
                          <h6 className="text-sm">
                            {breakTime.timestamp} - {breakTime.breakTimestamp}
                          </h6>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="w-full px-4">
            <div className="flex gap-2">
              <img src={icon.activityProgress} alt="" />
              <h4 className="text-base">Other Activity Summary</h4>
            </div>
            <div className="grid grid-cols-2 gap-2 px-5">
              <div className="flex flex-col items-center">
                <h1 className="text-xl">{workingHours || "0H : 0M"}</h1>
                <h6 className="text-sm whitespace-nowrap">Working hours</h6>
              </div>

              <div className="flex flex-col items-center">
                <h1 className="text-xl">{totalBreakTime || "0H : 0M"}</h1>
                <h6 className="text-sm">Over all Break hours</h6>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="w-full mt-2">
            <div className="mt-3">
              <div className="flex flex-col gap-3  ">
                <div>
                  <h4 className="text-lg font-medium">Day Call Frequency </h4>
                  <div className="flex items-center justify-start gap-8 mt-2">
                    <div className="flex flex-col items-center">
                      <h1 className="text-xl font-semibold">
                        {callLogHistory.length}
                      </h1>
                      <h6 className="text-sm text-gray-600">Total Calls</h6>
                    </div>
                    <div className="flex flex-col items-center">
                      <h1 className="text-xl font-semibold">
                        {formatCallTime(totalCallTime)}
                      </h1>
                      <h6 className="text-sm text-gray-700">Total Call Time</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <Chart
                ref={chartRef}
                type="line"
                data={chartData}
                options={{
                  ...chartOptions, // Ensure to retain your existing options
                  responsive: true,
                  maintainAspectRatio: false, // Allow custom height
                  scales: {
                    x: {
                      grid: {
                        display: false, // Disable grid lines on the x-axis
                      },
                    },
                    y: {
                      grid: {
                        display: false, // Disable grid lines on the y-axis
                      },
                    },
                  },
                }}
                style={{ height: "300px", width: "100%" }} // Set height via style
              /> */}

            <Chart
              ref={chartRef}
              type="line"
              data={chartData}
              options={chartOptions}
              style={{ height: "300px", width: "100%" }}
            />

            {selectedTime && (
              <div className="mt-2">
                <p className="text-xl">Selected Time: {selectedTime}</p>
                <p className="text-lg">Call Count: {callCount}</p>
              </div>
            )}
          </div>
          <div className="mt-2">
            {/* <div className="w-6/12 overflow-y-auto customScrollbar p-2 h-80"> */}
            <CallLog callLogHistory={callLogHistory} />
          </div>
        </div>
      </Modal>

      <ActivityTabelFilter
        visible={isFilterOpen}
        onHide={() => {
          setIsFilterOpen(false);
        }}
        setEndDate={setEndDate}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        handleApplyFilter={handleApplyFilter}
        clearFilters={clearFilters}
        setStartType={setStartType}
        startType={startType}
      />
    </div>
  );
};

export default TodayteamActivity;
